import React, { useEffect, useRef, useState, useCallback } from 'react';

const InactivityLogout = () => {
const [showWarning, setShowWarning] = useState(false);
const warningTimerRef = useRef(null);
const logoutTimerRef = useRef(null);

const WARNING_TIME = 25 * 60 * 1000; // 25 minutes
const LOGOUT_TIME = 5 * 60 * 1000;   // 5 minutes after warning

   const resetTimers = useCallback(() => {
      if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
      setShowWarning(false);

      warningTimerRef.current = setTimeout(() => {
         setShowWarning(true);

         logoutTimerRef.current = setTimeout(() => {
            logout();
         }, LOGOUT_TIME);
      }, WARNING_TIME);
   }, [WARNING_TIME, LOGOUT_TIME]); // include dependencies used inside the callback


   const logout = () => {
      alert('Logging out due to inactivity...');
      window.location.href = '/logout'; // or dispatch logoff if using Redux
   };

   useEffect(() => {
      const events = ['mousemove', 'keydown', 'click', 'scroll'];
      events.forEach(event => window.addEventListener(event, resetTimers));
      resetTimers();

      return () => {
         events.forEach(event => window.removeEventListener(event, resetTimers));
         if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
         if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
      };
   }, [resetTimers]);

   return (
      <>
         {showWarning && (
         <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
               <div className="modal-content border-danger">
               <div className="modal-header bg-warning text-dark">
                  <h5 className="modal-title">Inactivity Warning</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={resetTimers} />
               </div>
               <div className="modal-body">
                  <p>You will be logged out in 5 minutes due to inactivity.</p>
                  <p>Move your mouse or press a key to stay logged in.</p>
               </div>
               <div className="modal-footer">
                  <button onClick={resetTimers} className="btn btn-primary">
                     Stay Logged In
                  </button>
               </div>
               </div>
            </div>
         </div>
         )}
      </>
   );
};

export default InactivityLogout;
